// styledComponents.js
import {  styled } from "@mui/system";
import {
  Table,
  TableCell,
  Box,
  IconButton,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  TableRow,
} from "@mui/material";

export const BulkUploadInputLabel = styled("p")({
  color: "#fff",
  fontSize: "1.5rem",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: "600",
  marginBottom: "0.9rem",
  "@media (max-width: 1280px)": {
    fontSize: "1.2rem",
  },
  "@media (max-width: 480px)": {
    fontSize: "1rem",

  }
})


export const DownloadLinkLabel = styled("span")({
  color: "#03a4bd",
  textDecoration: "underline",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontSize: "1rem",
  fontWeight: "600",
  cursor: "pointer",
  position: "relative",  
  "&:hover": {
    textDecoration: "underline",
  },
  "&:not(:last-child)::after": {
    content: '""',  
    position: "absolute",
    top: "0",
    right: "-15px", 
    width: "2px",   
    height: "100%",
    backgroundColor: "#3F185B", 
  },
 
});
export const DownloadLinks = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  gap: "30px",
  margin: "-0.2rem auto 1rem",
  [theme.breakpoints.down("sm")]: {
    // flexDirection: "column",
    // alignItems: "center",
    gap: "15px", // less gap for stacked links
  },
  "@media (max-width: 1024px)": {
    margin: "0.1rem auto 1rem",
  },
  "@media (max-width: 768px)": {
    margin: "0.2rem auto 1rem",
  },
  "@media (max-width: 480px)": {
    margin: "-0.2rem auto 1rem",
    
  }
}));

export const UploadButton = styled(Button)({
  width: "100%",
  maxWidth: "380px", 
  marginBottom: "1.5rem !important",
  borderRadius: "12px",
  textTransform: "none",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: 600,
  fontSize: "1rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.9rem 1rem",
  backdropFilter: "blur(8px)", 
  background: "rgba(30, 41, 59, 0.6)", 
  border: "1px solid rgba(255,255,255,0.15)",
  color: "#fff",
  transition: "all 0.3s ease",
  cursor: "pointer",

  ".upload-icon": {
    width: "20px",
    height: "20px",
    marginLeft: "0.5rem",
  },

 ".file-name": {
  flex: 1,
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: "#fff", 
  fontWeight: "600",
  fontSize: "1rem",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  transition: "color 0.3s ease",
},

"& .file-name.placeholder": {
  color: "rgba(255,255,255,0.5) !important", 
  fontWeight: "400",
},
  "&:hover": {
    border: "1px solid rgba(34, 211, 238, 0.8)",
    boxShadow: "0 0 12px rgba(34, 211, 238, 0.6)",
    background: "linear-gradient(135deg, #1f2a40, #3b4b66)", // slightly lighter gradient
  },

  "&:focus": {
    border: "1px solid rgba(34, 211, 238, 0.8)",
    boxShadow: "0 0 12px rgba(34, 211, 238, 0.6)",
    background: "linear-gradient(135deg, #1f2a40, #3b4b66)",
  },

  "@media (max-width: 768px)": {
    maxWidth: "300px",
    fontSize: "0.875rem",
  },

  "@media (max-width: 480px)": {
    maxWidth: "280px",
    fontSize: "0.8rem",
    padding: "0.5rem 0.8rem",
  },
});

export const ErrorText = styled(Typography)({
  color: "red",
  marginTop: "0.5rem",//8px
  fontSize:"1rem",//16px
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  "@media (max-width: 1280px)": {
    fontSize:"0.8rem",//14px
    marginTop: "0.3rem",//8px
  }
})



export const SingleCveErrorText = styled(ErrorText)({
  color: "red",
  marginTop: "0.4rem",
  fontSize:"1rem",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  "@media (max-width: 1280px)": {
    fontSize:"0.8rem",
    marginTop: "0.6rem",
  }
});

export const BulkCveErrorText = styled(ErrorText)({
  color: "red",
  margin: "-1rem auto 1rem",
  fontSize:"1rem",//16px
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  "@media (max-width: 1280px)": {
    fontSize:"0.8rem",
    marginTop: "0.2rem",
  }});


export const CenteredTableContainer = styled("div")({
  display: "flex",
  justifyContent: "center",  
  alignItems: "center",  
  width: "100%", 
  overflowX: "auto",
  marginTop: "6rem",
  position: "relative",
  zIndex: 1,
});



export const StyledTable = styled(Table)({
  width: "80%", 
  maxWidth: "1440px",
  marginLeft: "8%", 
  marginBottom:"30px",
  borderCollapse: "collapse",
  tableLayout: "fixed",
  "@media (max-width: 509px), (max-device-width: 509px) and (orientation: portrait)": {
    width: "100%", 

  },
  "@media (max-width: 480px)": {
    width: "90%", 
    },
  "@media (max-width: 270px)": {
    width: "100%", 
    },
});


export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: "none", 
  // '& > *:nth-child(4)': {
  //   borderRadius: '0px !important', 
  // },

  '& > *:nth-child(1)': {
    borderTopLeftRadius: '1.875rem',//30px
  },
  '& > *:nth-child(3)': {
    borderTopRightRadius: '1.875rem', //30px
  },
  "@media (max-width: 425px)": {
    '& > *:nth-child(1)': {
      borderTopLeftRadius: '1.5rem',//30px
    },
    '& > *:nth-child(3)': {
      borderTopRightRadius: '1.5rem', //30px
    },  
    },
  "@media (max-width: 270px)": {
    '& > *:nth-child(1)': {
      borderTopLeftRadius: '1.5rem',//30px
    },
    '& > *:nth-child(3)': {
      borderTopRightRadius: '1.5rem', //30px
    },  
    },
}));

export const StyledTableHeadCell = styled(TableCell)(
  ({ first, middle, last }) => ({
    textAlign: "center",
    color: "#FFFFFF",
    fontSize: "1.250rem",//20px
    fontWeight: "600",
    lineHeight: "150%",
    padding: "0.9rem",//15px
    fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    borderLeft: "none !important",
    borderRight: "none !important",
    backgroundColor: "#253b6a",
    background: "linear-gradient(135deg, #1e293b, #0f172a)", 
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",

    width: first ? "30%" : middle ? "30%" : last ? "30%" : "0.1% !important", 

    "@media (max-width: 1280px)": {
      fontSize: "1rem",//16px
      padding:"0.8rem"
    },
    "@media (max-width: 509px), (max-device-width: 509px) and (orientation: portrait)": {
      fontSize: "1rem",//16px
    },
    "@media (max-width: 470px)": {
      fontSize: "12px",
    },
    "@media (max-width: 360px)": {
      fontSize: "8px",
    }
  })
);

export const StyledTableBodyCell = styled(TableCell)(
  ({ bold, noBottomBorder, isLast, isToggleColumn, isFirst,expandedIndex, index  }) => ({
    textAlign: isToggleColumn ? "left" : "center",
    padding: isToggleColumn ? "0px" : "8px !important",
    fontSize: "1.250rem", // 20px
    lineHeight: "150%",
    color: bold ? "#3F185B" : "#000",
    fontWeight: bold ? "600" : "500",
    // borderLeft: isFirst ? "none" : isToggleColumn ? "none" : "2px solid  rgba(170, 170, 204, 0.50)",
    borderRight: isLast ? "none" : isToggleColumn ? "none" : "1.3px solid #1e293b",
    
    borderBottomLeftRadius: isFirst && expandedIndex === index ? "15px" : "0px",
    borderBottomRightRadius: isLast && expandedIndex === index ? "15px" : "0px",
    
     borderBottom: isToggleColumn || noBottomBorder
  ? "none" 
  : "1px solid #1e293b",

    
    fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    background: isToggleColumn ? "transparent" : "#FFFFFFBF",
    width: isToggleColumn ? "10px" : "auto",
    "@media (max-width: 1280px)": {
      fontSize: "1rem",
    },
    "@media (max-width: 509px), (max-device-width: 509px) and (orientation: portrait)": {
      fontSize: "0.8rem",
    },
    "@media (max-width: 470px)": {
      fontSize: "10px",
    },
    "@media (max-width: 360px)": {
      fontSize: "8px",
    },
  })
);


export const ToggleIconButton = styled(IconButton)({
  padding: "0 !important",
  "&:hover": {
    backgroundColor: "transparent !important",
  },
  
});

export const BulkCustomAccordion = styled(Accordion)(({ theme, expanded }) => ({
  border: "none !important",
  borderRadius: expanded ? "10px !important" : "10px !important",
  margin:"0.938rem 0  !important" ,//15px
  color: "#fff !important",
  marginTop: "10px",
  background:"#222324e6",
  border:"1px solid rgba(112,112,112,.3)",
  // boxShadow: "20px 8px 30px #0009",
  boxShadow: `
  2px 2px 20px rgba(0,0,0,0.4),  
  -2px -2px 5px rgba(0,0,0,0.05)  
`

}));

export const BulkCustomAccordionSummary = styled(AccordionSummary)(
  ({ theme, expanded }) => ({
    padding: "2px 24px",
    "&.Mui-expanded": {
      margin: "0 !important", 
      minHeight: "unset !important", 
  },
    "& .MuiTypography-root": {
      fontSize: "0.625rem !important",//10px
      color: expanded ? "#3F185B" : "#000",
      transition: "font-size 0.3s ease, color 0.3s ease",
      fontWeight: "600",
    },
   
  })
);

export const BulkCustomAccordionDetails = styled(AccordionDetails)(
  ({ theme }) => ({
    padding:"0px 20px 15px 20px",
    color: "#FFF !important",
    // color: "#000",
    fontSize: "1.5rem",//16px
    fontWeight: "500",
    wordBreak:"break-word",
    fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important",
    transition: "background-color 0.3s ease, padding 0.3s ease",
    overflowWrap: "break-word",
    lineHeight:"100%",
    "@media (max-width: 1280px)": {
      fontSize: "0.9rem",
    },
    "@media (max-width: 509px), (max-device-width: 509px) and (orientation: portrait)": {
      fontSize: "0.7rem",
    },
    "@media (max-width: 480px)": {
      fontSize: "0.625rem",//10px
    },
    "@media (max-width: 425px)": {
    }
  })
  
);

export const BulkCustomTypography = styled("span")(({ theme, expanded }) => ({
  fontSize: "1.4rem",//16px
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important",
  fontWeight: "600",
  color: expanded ? "#70F0A3" : "rgba(255,255,255,0.75)",
  "@media (max-width: 1280px)": {
    fontSize: "0.9rem",
  },
  "@media (max-width: 509px), (max-device-width: 509px) and (orientation: portrait)": {
    fontSize: "0.9rem",
  } ,
  "@media (max-width: 480px)": {
    fontSize: "0.7rem",//10px
  },
  "@media (max-width: 425px)": {
  }
}));

export const IconImage = styled("img")(({ theme }) => ({
  width: "30px",
  height: "30px",
  "@media (max-width: 1280px)": {
    width: "24px",
    height: "24px",
  },
  "@media (max-width: 480px)": {
    width: "14px",
    height: "14px",
  },

  "@media (max-width: 425px)": {
  },
  "@media (max-width: 360px)": {
    width: "14px",
    height: "14px",
  }
}));

export const BulkScoreContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "3px",
  width: "100%",
  flexWrap: "nowrap",
  position: "absolute",
  left: "50%",
  bottom: 0,
  transform: "translate(-50%, 60%)",

  "& .score": {
    backgroundColor: "#253b6a",
    background: "linear-gradient(135deg, #1e293b, #0f172a)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
    color: "#FFF",
    textAlign: "center",
    lineHeight: "1.2",
    // padding: "clamp(0.5rem, 1vw + 0.3rem, 1.125rem) clamp(0.6rem, 4vw + 0.2rem, 3.750rem)",  
     padding: "clamp(0.5rem, 1vw + 0.3rem, 1.125rem) clamp(0.5rem, 3vw + 0.2rem, 3rem)",
    "& .scoreValue": {
      fontSize: "clamp(0.625rem, 1.5vw + 0.3rem, 1.2rem)",
      fontWeight: "600",
      fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      color: "#22d3ee",
      display: "block",
    },

    "& .scoreText": {
      fontSize: "clamp(0.5rem, 1.2vw + 0.25rem, 1rem)",
      fontWeight: "600",
      fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      color: "#70F0A3",
    },
  },

  "& .epssScore": {
    borderRadius: "0 clamp(25px, 4vw, 50px) 0 0",
  },

  "& .cprScore": {
    borderRadius: "clamp(25px, 4vw, 50px) 0 0 0",
  },
}));



export const ReferencesContainer = styled("div")(({ theme }) => ({
  padding: 0

}))
export const ReferenceItem = styled('div')({
  marginBottom: '2px',
});

export const ReferenceLink = styled('a')({
  color: '#0073e6',
  textDecoration: 'none',
  fontSize: "1rem",//16px
  fontWeight: "500",
  fontFamily:"Noto Sans",
  "@media (max-width: 509px), (max-device-width: 509px) and (orientation: portrait)": {
    fontSize:"0.8rem"
  },
  "@media (max-width: 480px)": {
    fontSize:"0.688rem"//11px
  }
});

export const AccordionSummaryValues = styled("span")({
  color: "#FFF !important",
  fontSize: "1.1rem",//16px
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: "500",
  lineHeight:"150%",
  "@media (max-width: 509px), (max-device-width: 509px) and (orientation: portrait)": {
    fontSize:"0.8rem"
  },
  "@media (max-width: 480px)": {
    fontSize:"0.688rem"//11px
  }
})
export const NoUnderlineLink = styled("a")({
  textDecoration: "none", 
});


